// Exports
// -------

export default function ScheduledEventUser(type, user) {
  if (!user) {
    return;
  }

  const {
    display_name: displayName,
    entity_uuid: entityUuid,
    first_name: firstName,
    id,
    last_name: lastName = '',
    uuid,
  } = user;

  return {
    displayName: displayName || `${firstName} ${lastName.substring(0, 1)}`.trim(),
    firstName,
    id,
    lastName,
    // Notes:
    // 1. Tutoring session events inappropriately place the `uid` in the `uuid` field, so we need
    //    to check for an `entityUuid` first
    // 2. Course meeting events have different participant schemas for client vs student users, so
    //    we need to do a little extra work for the appropriate uuid
    uuid: entityUuid || uuid || user[`${type}_id`],
  };
}
